import {Component, Input, OnInit} from "@angular/core";
import {WarmwassercheckAnfrage} from "../anfrage/warmwassercheck.anfrage";

@Component({
    selector: 'app-ergebnis-analyse',
    templateUrl: './ergebnis.analyse.component.html',
    standalone: false
})

export class ErgebnisAnalyseComponent implements OnInit {
  /**
   * get warmwassercheck anfrage
   */
  @Input() anfrage: WarmwassercheckAnfrage;

  /**
   * Placeholder used in all texts
   */
  @Input() textPlaceholder: any = {};

  /**
   * Prefix for all used textkeys
   */
  textKeyPrefix: string = 'warmwassercheck.ergebnis.analyse';

  /**
   * toggle for the hint text
   */
  showHint: boolean = false;

  /**
   * @inheritDoc
   */
  ngOnInit() {
    // get updated values of placeholder from backend if class changes
    this.textPlaceholder = this.anfrage?.result?.placeholder ? this.anfrage?.result?.placeholder : {};
  }

}
